// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2N5Yl","label":"Radio_label__1rE5G","checkMark":"Radio_checkMark__2zhW-","disabled":"Radio_disabled__1ZLiP"};